import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-per-accademia',
  templateUrl: './per-accademia.component.html',
  styleUrls: ['./per-accademia.component.css']
})
export class PerAccademiaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
